module.exports = __webpack_public_path__ + "img/Close-darkmode.bf8108b6.svg";